/**
 * Route for `igaming-pricing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPricingPage } from "../features/igaming-pricing/IgamingPricingPage";

export const igamingPricingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-pricing",
	component: IgamingPricingPage,
});

export default igamingPricingRoute;
